export default __webpack_public_path__ + "static/media/download_fiche_backcasting.07d77e0e.pdf";